import { useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { formatDateTimeWAT } from "@/lib/format";

const TYPES = ["", "DAR", "INCIDENT", "PASSDOWN", "HOURLY"];

export const PortalReports = () => {
  const [reports, setReports] = useState([]);
  const [sites, setSites] = useState([]);
  const [type, setType] = useState("");

  const loadSites = useCallback(async () => {
    const r = await api.get("/sites");
    setSites(r.data);
  }, []);

  const loadReports = useCallback(async () => {
    const q = type ? `?type=${type}` : "";
    const r = await api.get(`/reports${q}`);
    setReports(r.data);
  }, [type]);

  useEffect(() => { loadSites(); }, [loadSites]);
  useEffect(() => { loadReports(); }, [loadReports]);

  const sitesById = useMemo(
    () => Object.fromEntries(sites.map(s => [s.id, s.name])),
    [sites]
  );

  const rows = useMemo(() => reports.map(r => ({
    id: r.id,
    created_at: r.created_at,
    type: r.type,
    site: sitesById[r.site_id] || "—",
    text: r.text,
  })), [reports, sitesById]);

  return (
    <div className="space-y-4">
      <div className="s-card-light flex items-center gap-3">
        <span className="text-muted" style={{ fontSize: 13 }}>Filter:</span>
        <select value={type} onChange={(e) => setType(e.target.value)} className="s-input light" style={{ width: 180 }} data-testid="portal-filter">
          <option value="">All types</option>
          {TYPES.filter(Boolean).map(t => <option key={t}>{t}</option>)}
        </select>
        <span className="text-muted" style={{ fontSize: 12 }}>{rows.length} reports</span>
      </div>

      <div className="s-card-light" style={{ padding: 0 }}>
        <table className="s-table s-table-light">
          <thead><tr><th>Date</th><th>Type</th><th>Site</th><th>Summary</th></tr></thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id}>
                <td className="mono">{formatDateTimeWAT(r.created_at)}</td>
                <td>{r.type}</td>
                <td>{r.site}</td>
                <td style={{ maxWidth: 320, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.text}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
